import React, { useImperativeHandle, useRef, useEffect, forwardRef, useState } from "react";
import { Modal } from 'bootstrap';
import { useSelector } from "react-redux";
import HttpAPICall from "../../../services/HttpAPICall";
import { toast } from "react-toastify";
import TapIcon from "../../../services/TapIcon";
import { HRM_API_BASE_URL_2 } from "../../../services/TapApiUrls";
import Loader from "../../../components/ui/Loader/Loader";
import DatePicker from "react-datepicker";
import moment from "moment";
import uuid from "react-uuid";
import TapSelect from "../../../components/ui/TapSelect";

const EmployeeSiteChange = forwardRef((props, ref) => {
    const access_token = useSelector(state => state.auth.access_token);
    const iamUserSite = useSelector(state => state.app.user_sites);

    const modalElem = useRef(null);
    const searchModal = useRef(null);
    const modalID = uuid();

    const [formData, setFormData] = useState({
        site_id: "",
        site_since_date: "",
        remark: "",
    });
    const [selectedEmployees, setSelectedEmployees] = useState([]);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [iamUserSites, setIamUserSites] = useState([]);
    const [commonSiteId, setCommonSiteId] = useState("");

    useEffect(() => {
        modalElem.current = document.getElementById(modalID);
        searchModal.current = new Modal(modalElem.current, { keyboard: false, backdrop: false });

        if (iamUserSite && iamUserSite.length > 0) {
            const siteOptions = iamUserSite.map(site => ({
                value: site.id,
                label: `${site.site_name} (${site.site_code})`
            }));
            setIamUserSites(siteOptions);
        }

        return () => {
            if (searchModal.current) {
                searchModal.current.dispose();
            }
        };
    }, [iamUserSite]);

    useImperativeHandle(ref, () => ({
        initModalHandlerEmployee: (data) => {
            if (data && data.isBulk) {
                setSelectedEmployees(data.employees || []);
                if (data.employees && data.employees.length > 0) {
                    setCommonSiteId(data.employees[0].site_id || "");
                }
                setFormData({
                    site_id: "",
                    site_since_date: "",
                    remark: "",
                });
            } else {
                setSelectedEmployees(data ? [data] : []);
                setCommonSiteId(data?.site_id || "");
                setFormData({
                    site_id: "",
                    site_since_date: "",
                    remark: "",
                });
            }
            openModalHandle();
        }
    }));

    const searchModalOpen = () => searchModal.current && searchModal.current.show();

    const searchModalClose = () => {
        searchModal.current && searchModal.current.hide();
        resetForm();
    };

    const openModalHandle = () => {
        searchModalOpen();
    };

    const handleTapSelectChange = (selectedOption, fieldName) => {
        setFormData(prev => ({
            ...prev,
            [fieldName]: selectedOption ? selectedOption.value : ""
        }));
    };

    const handleDateChange = (date, fieldName) => {
        setFormData(prev => ({
            ...prev,
            [fieldName]: date ? moment(date).format('YYYY-MM-DD HH:mm:ss') : ""
        }));
    };

    const handleRemarkChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        const payload = {
            ids: selectedEmployees.map(emp => emp.enc_id),
            site_id: formData.site_id,
            site_since_date: formData.site_since_date,
            remark: formData.remark || "",
        };

        HttpAPICall.withAthorization("PUT", HRM_API_BASE_URL_2 + '/multiple_employees_site_change', access_token, {}, payload, (response) => {
            toast.success(response.data.msg , {
                position: toast.POSITION.TOP_RIGHT
            });
            searchModalClose();
            if (props.onSuccess) {
                props.onSuccess();
            }
        }).catch(error => {
            toast.error(error?.response?.data?.message , {
                position: toast.POSITION.TOP_RIGHT
            });
        }).finally(() => {
            setIsSubmitting(false);
        });
    };

    const resetForm = () => {
        setFormData({
            site_id: "",
            site_since_date: "",
            remark: "",
        });
        setSelectedEmployees([]);
        setIsSubmitting(false);
        setCommonSiteId("");
    };

    const renderEmployeeNames = () => {
        if (selectedEmployees.length === 0) return "-";
        
        const firstTwoNames = selectedEmployees.slice(0, 2).map(emp => {
            return emp.name ||
                emp.employee_name ||
                emp.full_name ||
                (emp.first_name && emp.last_name ? `${emp.first_name} ${emp.last_name}` : null) ||
                emp.email ||
                `Employee ${emp.id || emp.enc_id || ''}` ||
                'Unknown';
        }).filter(name => name).join(', ');

        const remainingCount = selectedEmployees.length - 2;

        if (remainingCount > 0) {
            return `${firstTwoNames} +${remainingCount} more`;
        }

        return firstTwoNames;
    };

    return (
        <div className="modal fade" id={modalID} tabIndex="-1" ref={modalElem}>
            <div className="modal-dialog modal-lg">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">
                            Bulk Site Change
                        </h5>
                        <button
                            type="button"
                            className="btn-close"
                            data-bs-dismiss="modal"
                            onClick={searchModalClose}
                            aria-label="Close"
                        ></button>
                    </div>
                    <form onSubmit={handleSubmit}>
                        <div className="modal-body">
                                <>
                                    <div className="row mb-3">
                                        <label className="col-sm-3 col-form-label col-form-label-sm ">
                                            Employees
                                        </label>
                                        <div className="col-sm-9">
                                            <input
                                                type="text"
                                                className="form-control form-control-sm bg-light"
                                                value={renderEmployeeNames()}
                                                disabled
                                            />
                                        </div>
                                    </div>
                                    <div className="row mb-3">
                                        <label className="col-sm-3 col-form-label col-form-label-sm  require">
                                         Site
                                        </label>
                                        <div className="col-sm-9">
                                            <TapSelect
                                                options={iamUserSites.filter(site => site.value !== commonSiteId)}
                                                changeEvent={(selectedOption) => {
                                                    handleTapSelectChange(selectedOption, "site_id");
                                                }}
                                                isSearchable={true}
                                                isClearable={true}
                                                menuPlacement="bottom"
                                                value={iamUserSites.find(
                                                    (s) => formData.site_id === s.value
                                                )}
                                                placeholder="Select New Site"
                                                containerHeight="30px"
                                                fontSize="93%"
                                                required={true}
                                            />
                                        </div>
                                    </div>

                                    <div className="row mb-3">
                                        <label className="col-sm-3 col-form-label col-form-label-sm  require">
                                            Transfer Date
                                        </label>
                                        <div className="col-sm-9">
                                            <DatePicker
                                                selected={formData.site_since_date ? moment(formData.site_since_date).toDate() : null}
                                                onChange={(date) => handleDateChange(date, "site_since_date")}
                                                dateFormat="dd-MMM-yyyy hh:mm a"
                                                className="form-control form-control-sm"
                                                showMonthDropdown
                                                showYearDropdown
                                                showTimeSelect
                                                timeIntervals={5}
                                                timeCaption="Time"
                                                autoComplete="off"
                                                scrollMonthYearDropdown
                                                required
                                                maxDate={new Date()}
                                                placeholderText="Please Enter Transfer Date"
                                            />
                                        </div>
                                    </div>

                                    <div className="row mb-3">
                                        <label className="col-sm-3 col-form-label col-form-label-sm ">
                                            Remarks
                                        </label>
                                        <div className="col-sm-9">
                                            <textarea
                                                name="remark"
                                                rows="3"
                                                className="form-control form-control-sm"
                                                value={formData.remark}
                                                placeholder="Please Enter Remarks"
                                                onChange={handleRemarkChange}
                                            />
                                        </div>
                                    </div>
                                </>
                        </div>
                        <div className="modal-footer">
                            <button
                                type="button"
                                className="btn btn-secondary"
                                onClick={searchModalClose}
                                disabled={isSubmitting}
                            >
                                Close
                            </button>
                            <button
                                type="submit"
                                className="btn btn-primary"
                                disabled={isSubmitting}
                            >
                                Save
                                {isSubmitting &&
                                    <TapIcon.FontAwesomeIcon
                                        icon={TapIcon.faSyncAlt}
                                        className="fa-spin ms-2"
                                    />
                                }
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
});

export default EmployeeSiteChange;